module.exports = __webpack_public_path__ + "assets/img/23_32.e76183c9.jpg";